
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.888 4.564v-.033A6.636 6.636 0 006.662.176 6.627 6.627 0 00.435 4.531v.033a6.55 6.55 0 000 4.46v.033a6.636 6.636 0 006.227 4.355 6.626 6.626 0 006.226-4.355v-.033a6.55 6.55 0 000-4.46zM1.516 8.122a5.195 5.195 0 010-2.655H2.75a11.113 11.113 0 000 2.655H1.516zm.544 1.327h.928c.156.592.378 1.164.663 1.706A5.307 5.307 0 012.06 9.449zm.928-5.31H2.06a5.308 5.308 0 011.571-1.705 8.07 8.07 0 00-.643 1.705zm2.997 7.766a4.208 4.208 0 01-1.61-2.456h1.61v2.456zm0-3.783H4.09a9.54 9.54 0 010-2.655h1.896v2.655zm0-3.983h-1.61a4.208 4.208 0 011.61-2.455v2.455zm5.252 0h-.928a8.066 8.066 0 00-.663-1.705 5.308 5.308 0 011.591 1.705zM7.312 1.684a4.208 4.208 0 011.61 2.455h-1.61V1.684zm0 10.22V9.45h1.61a4.208 4.208 0 01-1.61 2.456zm1.896-3.782H7.312V5.467h1.896a9.54 9.54 0 010 2.655zm.458 3.033a8.066 8.066 0 00.663-1.706h.928a5.307 5.307 0 01-1.591 1.706zm2.115-3.033h-1.234c.054-.44.08-.884.08-1.328 0-.444-.026-.887-.08-1.327h1.234c.23.87.23 1.785 0 2.655z","fill":"#C4C4C4"}})])
          )
        }
      }
    